import { useField, useFormikContext } from "formik";
import { ContentEditable, Props } from "../ContentEditable";

export interface FormProps extends Omit<Props, "value" | "onChange"> {
  name: string;
  validateOnMount?: boolean;
  forceLightTheme?: boolean;
}
const FormContentEditable = (props: FormProps) => {
  const { name, validateOnMount, ...rest } = props;
  const [field, meta, { setValue }] = useField(name);

  const { touched } = useFormikContext();
  const isError = (!!validateOnMount || !!touched) && !!meta.error;

  return (
    <ContentEditable
      {...rest}
      value={field.value}
      onChange={setValue}
      isError={isError}
      errorMsg={meta.error}
    />
  );
};

export default FormContentEditable;
